import {createAction} from "@reduxjs/toolkit";
import {Recommendation} from "src/models/Recommendation";

const RecommendationActions = {
    SET_RECOMMENDATION_LIST: createAction<Recommendation[]>('SET_RECOMMENDATION_LIST'),
    CLEAR_RECOMMENDATION: createAction<void>('CLEAR_RECOMMENDATION')
}

export default RecommendationActions;
